module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: '0',
        title: 'Table Selection',
        description: 'Select #0 Row'
      }),
      expression: "{ keys:'0', title:'Table Selection', description:'Select #0 Row'}"
    }],
    on: {
      "shortkey": function($event) {
        _vm.selectRow('0')
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: '1',
        title: 'Table Selection',
        description: 'Select #1 Row'
      }),
      expression: "{ keys:'1', title:'Table Selection', description:'Select #1 Row'}"
    }],
    on: {
      "shortkey": function($event) {
        _vm.selectRow('1')
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: '2',
        title: 'Table Selection',
        description: 'Select #2 Row'
      }),
      expression: "{ keys:'2', title:'Table Selection', description:'Select #2 Row'}"
    }],
    on: {
      "shortkey": function($event) {
        _vm.selectRow('2')
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: '3',
        title: 'Table Selection',
        description: 'Select #3 Row'
      }),
      expression: "{ keys:'3', title:'Table Selection', description:'Select #3 Row'}"
    }],
    on: {
      "shortkey": function($event) {
        _vm.selectRow('3')
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: '4',
        title: 'Table Selection',
        description: 'Select #4 Row'
      }),
      expression: "{ keys:'4', title:'Table Selection', description:'Select #4 Row'}"
    }],
    on: {
      "shortkey": function($event) {
        _vm.selectRow('4')
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: '5',
        title: 'Table Selection',
        description: 'Select #5 Row'
      }),
      expression: "{ keys:'5', title:'Table Selection', description:'Select #5 Row'}"
    }],
    on: {
      "shortkey": function($event) {
        _vm.selectRow('5')
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: '6',
        title: 'Table Selection',
        description: 'Select #6 Row'
      }),
      expression: "{ keys:'6', title:'Table Selection', description:'Select #6 Row'}"
    }],
    on: {
      "shortkey": function($event) {
        _vm.selectRow('6')
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: '7',
        title: 'Table Selection',
        description: 'Select #7 Row'
      }),
      expression: "{ keys:'7', title:'Table Selection', description:'Select #7 Row'}"
    }],
    on: {
      "shortkey": function($event) {
        _vm.selectRow('7')
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: '8',
        title: 'Table Selection',
        description: 'Select #8 Row'
      }),
      expression: "{ keys:'8', title:'Table Selection', description:'Select #8 Row'}"
    }],
    on: {
      "shortkey": function($event) {
        _vm.selectRow('8')
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: '9',
        title: 'Table Selection',
        description: 'Select #9 Row'
      }),
      expression: "{ keys:'9', title:'Table Selection', description:'Select #9 Row'}"
    }],
    on: {
      "shortkey": function($event) {
        _vm.selectRow('9')
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": _vm.tablename
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(item) {
    return _c('th', [_vm._v(_vm._s(item.name))])
  }))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2bd0137c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bd0137c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/corecontrols/datatable/datatable.scp.html
// module id = 463
// module chunks = 0